import * as React from 'react'

import { Box, CollapsableCard, Icon, Text } from '@factorialco/deprecated-design-system'

import * as styles from 'modules/expenses/components/common/CardsLandingPage/Content/FAQSection/index.vanilla.css'

interface TitleProps {
  onClickRow: (event: MouseEvent) => void
  title: string
  isOpen: boolean
}

const Title = ({ onClickRow, isOpen, title }: TitleProps) => {
  const chevronIconName = isOpen ? 'chevron-up' : 'chevron-down'
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      cursor="pointer"
      onClick={onClickRow}
    >
      <Text.Normal weight="medium">{title}</Text.Normal>
      <Icon.Small icon={chevronIconName} color="grey1000" />
    </Box>
  )
}

interface CardProps {
  open: boolean
  title: string
  content: React.ReactNode
  onClick: () => void
}

const Card: React.FC<CardProps> = ({ open, title, content, onClick }) => (
  <CollapsableCard
    open={open}
    Card={
      <Title
        onClickRow={(e) => {
          e.preventDefault()
          onClick()
        }}
        isOpen={open}
        title={title}
      />
    }
    Content={
      <Text.Normal>
        <Box flexDirection="column" gap="s16" className={styles.cardContent}>
          {content}
        </Box>
      </Text.Normal>
    }
  />
)

export default Card
